import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import * as Yup from 'yup'
import { Modal, Stack, Row, Col } from 'react-bootstrap'
import { alert } from '../../../../../utils/helper'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'
import { FormikProvider, FieldArray, useFormik } from 'formik'

import {
  GET_PRODUCT_FOR_AGENT,
  UPDATE_PRODUCT_FOR_AGENT,
  GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT,
} from '../../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import ProductDetails from '../steps/ProductDetails'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import { GLOBAL_CONSTANTS } from '../../../../../utils/GlobalConstants'

const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  editData: any

  refetchList: () => void
  salesData: any
  agentId: string
  agentLeaderList: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const EditAgentModel = ({
  show,
  handleClose,
  editData,
  refetchList,
  salesData,
  agentId,
  agentLeaderList,
}: Props) => {
  const [agentProd, setAgentProd] = useState<any>([])
  const [salesProducts, setSalesProducts] = useState<any>([])
  const [getAgentLeaderCode] = useLazyQuery(GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) =>
      formik.setFieldValue(
        'agentLeaderName',
        agentLeaderList.filter(
          (leader: any) => leader.leaderCode === data.getAgentLeaderInfoForAgent.leaderCode
        )[0].leaderName
      ),
  })
  useEffect(() => {
    const parseData = JSON.parse(editData)
    formik.setFieldValue('productIds', [])
    formik.setFieldValue('deletedProductId', [])
    formik.setFieldValue('agentFirstName', parseData.firstName)
    formik.setFieldValue('agentLastName', parseData.lastName)
    !parseData.loginUsername ? formik.setFieldValue('agentEmailId', parseData.emailId) : formik.setFieldValue('agentEmailId', '-')
    formik.setFieldValue('agentRepId', parseData.repId)
    parseData.loginUsername ? formik.setFieldValue('loginUsername', parseData.loginUsername) : formik.setFieldValue('loginUsername', '-')
    formik.setFieldValue('loginPassword', parseData.loginUsername ? '********' : '-')
    getProductsForAgents({
      variables: {
        agentId,
      },
    })

    getAgentLeaderCode({
      variables: {
        memberId: agentId,
      },
    })

    setSalesProducts(salesData.products)
  }, [editData])// eslint-disable-line react-hooks/exhaustive-deps

  const [getProductsForAgents] = useLazyQuery(GET_PRODUCT_FOR_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (agentProduct) => {
      setAgentProd({ products: agentProduct.getProductsForAgents })
    },
  })


  const validationSchema = Yup.object({
    agentFirstName: Yup.string().required('First Name required'),
    agentLastName: Yup.string().required('Last Name required'),
    agentEmailId: Yup.string().required('required'),

    loginPassword: Yup.string().test(
      'password-validation',
      'Invalid password',
      function (value) {
        if (!value || value.trim() === '') {
          return this.createError({ message: 'Password is required' })
        }
        if (value === '-' || value === '********' || !value) return true
        if (value.length < 8) return this.createError({ message: 'Minimum 8 characters required' })
        if (!/[a-z]/.test(value)) return this.createError({ message: 'At least one lowercase required' })
        if (!/[A-Z]/.test(value)) return this.createError({ message: 'At least one uppercase required' })
        if (!/\d/.test(value)) return this.createError({ message: 'At least one number required' })
        if (!/[^A-Za-z0-9]/.test(value)) return this.createError({ message: 'At least one symbol required' })
        return true
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      productIds: [],
      deletedProductId: [],
      agentFirstName: '',
      agentLastName: '',
      agentEmailId: '',
      agentLeaderName: '',
      agentRepId: '',
      loginUsername: '',
      loginPassword: '',
    },
    validationSchema,
    onSubmit: (values) => {
      updateAgent({
        variables: {
          updateAgentInputs: {
            memberId: agentId,
            ...(
              values.loginPassword !== '********' && values.loginPassword !== '-' && {
                password: values.loginPassword,
              }
            ),
            addProductIds: values.productIds.length ? values.productIds : null,
            removingIds: values.deletedProductId.length ? values.deletedProductId : null,
            salesChannelId: localStorage.getItem('salesEditId'),
            ...(JSON.parse(editData).firstName !== values.agentFirstName && {
              agentFirstName:
                JSON.parse(editData).firstName !== values.agentFirstName
                  ? values.agentFirstName
                  : null,
            }),
            leaderCode: Boolean(values.agentLeaderName)
              ? agentLeaderList.filter(
                (leader: any) => leader.leaderName === values.agentLeaderName
              )[0].leaderCode
              : null,
            ...(JSON.parse(editData).lastName !== values.agentLastName && {
              agentLastName:
                JSON.parse(editData).lastName !== values.agentLastName
                  ? values.agentLastName
                  : null,
            }),
            ...(JSON.parse(editData).agentRepId !== values.agentRepId && {
              agentRepId: values.agentRepId,
            }),
          },
        },
      })
    },
  })

  const [updateAgent, { loading }] = useMutation(UPDATE_PRODUCT_FOR_AGENT, {
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Agent updated successfully',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
      handleClose()
      refetchList()
    },
    onError: (error) => alert(error.message, 'error'),
  })
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={'modal-dialog-centered modal-fullscreen'}
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title'>
          {formik.values.agentFirstName} {formik.values.agentLastName}
        </h4>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => {
            formik.setTouched({})
            handleClose()
          }}
        >
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body d-flex flex-column overflow-hidden p-0'>
        <div className='modal-content d-flex flex-column flex-grow-1 overflow-hidden'>
          <div className='modal-md d-flex flex-column flex-grow-1 overflow-hidden'>
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit} className='d-flex flex-column flex-grow-1 overflow-hidden'>
                <FieldArray
                  name='agentList'
                  render={() => (
                    <div className='hover-scroll-overlay-y overflow-auto flex-grow-1 p-5'>
                      <Stack direction='vertical' gap={3} className='mb-3 mt-3 '>
                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <Col>
                            <label className='form-label'>
                              First Name <span className='h5 text-danger'>*</span>
                            </label>
                            <input
                              {...formik.getFieldProps('agentFirstName')}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter First Name'
                            />
                            <div>
                              {formik.touched.agentFirstName && (
                                <div className='fv-plugins-message-container'>
                                  <div
                                    data-field='appname'
                                    data-validator='notEmpty'
                                    className='fv-help-block'
                                  >
                                    {formik.errors.agentFirstName}
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col>
                            <label className='form-label'>
                              Last Name <span className='h5 text-danger'>*</span>
                            </label>
                            <input
                              {...formik.getFieldProps('agentLastName')}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter Last Name'
                            />
                            <div>
                              {formik.touched.agentLastName && (
                                <div className='fv-plugins-message-container'>
                                  <div
                                    data-field='appname'
                                    data-validator='notEmpty'
                                    className='fv-help-block'
                                  >
                                    {formik.errors.agentLastName}
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>

                        {(formik.values.loginUsername && formik.values.loginUsername !== '-') && <Row Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <Col>
                            <label className='form-label'>
                              User Name
                            </label>
                            <input
                              name={`loginUsername`}
                              value={formik.values.loginUsername}
                              onChange={formik.handleChange}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter User Name'
                              disabled
                            />
                          </Col>
                          <Col>
                            <label className='form-label'>
                              Login Password
                              <i
                                className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                                onClick={() => alert(`${"To change your password, remove all placeholder values and follow this condition: Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one symbol (e.g., TpvSolutions@123)."}`, 'info')}
                              />
                            </label>
                            <input
                              name={`loginPassword`}
                              value={formik.values.loginUsername ? formik.values.loginPassword : '-'}
                              onChange={formik.handleChange}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter Password'
                              readOnly={(!!formik.values.loginUsername && formik.values.loginUsername === '-')}
                            />
                            <div>
                              {formik.touched.loginPassword && (
                                <div className='fv-plugins-message-container'>
                                  <div
                                    data-field='Pssword'
                                    data-validator='notEmpty'
                                    className='fv-help-block'
                                  >
                                    {formik.errors.loginPassword}
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>}
                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          {(!formik.values.loginUsername || formik.values.loginUsername === '-') && <Col>
                            <label className='form-label'>
                              Email ID <span className='h5 text-danger'>*</span>
                            </label>
                            <input
                              name={`agentEmailID`}
                              value={formik.values.agentEmailId}
                              onChange={formik.handleChange}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter Email Id'
                              disabled
                            /></Col>}

                          <Col>
                            <label className='form-label'>RepId</label>
                            <input
                              {...formik.getFieldProps('agentRepId')}
                              className='form-control form-control-solid ms-2 w-100'
                              placeholder='Enter RepId'
                            />
                            <div>
                              {formik.touched.agentRepId && (
                                <div className='fv-plugins-message-container'>
                                  <div
                                    data-field='appname'
                                    data-validator='notEmpty'
                                    className='fv-help-block'
                                  >
                                    {formik.errors.agentRepId}
                                  </div>
                                </div>
                              )}
                            </div></Col>

                        </Row>

                        <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                          <Col>
                            <ProductDetails
                              isEdit={false}
                              formik={formik}
                              salesDatas={agentProd}
                              salesProducts={salesProducts}
                              label='Assigned Products'
                            />
                          </Col>
                        </Row>

                        <Row>
                          <label className='form-label'>Agent Leader</label>
                          <Dropdown
                            fieldName={`agentLeaderName`}
                            optionList={agentLeaderList?.map((leader: any) => ({
                              id: leader.leaderName,
                              value: leader.leaderName,
                            }))}
                            formik={formik}
                            selectedVal={formik.values.agentLeaderName}
                            handleSelectedItem={(e: any, fieldName: any) =>
                              formik.setFieldValue(`agentLeaderName`, e.value)
                            }
                          />
                        </Row>

                      </Stack>
                    </div>
                  )}
                />
                <div className='modal-footer flex-shrink-0'>
                  <button
                    type='button'
                    className='btn btn-light'
                    data-bs-dismiss='modal'
                    onClick={() => {
                      formik.setTouched({})
                      handleClose()
                    }}
                  >
                    Discard
                  </button>
                  <button type='submit' className='btn btn-primary' disabled={loading}>
                    Submit
                    {loading && (
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    )}
                  </button>
                </div>
              </form>
            </FormikProvider>
          </div>
        </div>
      </div>
    </Modal >,
    modalsRoot
  )
}

export { EditAgentModel }
